import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import { NgbCollapseModule, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { AssetTypeComponent } from './components/asset-type.component';
import { AssetTypeRoutingModule } from './asset-type-routing.module';

@NgModule({
  declarations: [AssetTypeComponent],
  imports: [
    AssetTypeRoutingModule,
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgxValidateCoreModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
  ],
})
export class AssetTypeModule {}

export function loadAssetTypeModuleAsChild() {
  return Promise.resolve(AssetTypeModule);
}
